<!-- 标记 -->
<template>
  <div class="flex-auto">
    <el-form
      ref="form"
      :model="markForm"
      :rules="rules"
      label-width="120px"
      class="mark-ruleForm"
    >
      <el-form-item
        :label="matchType === 1 ? '人员类型：' : '车主类型：'"
        prop="personnelType"
      >
        <el-select
          :disabled="recordMarked"
          v-model="markForm.personnelType"
          placeholder="请选择人员类型"
          clearable
          @change="peopleChange"
          style="width: 220px"
        >
          <el-option
            v-for="item in personnelTypeOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="外来人员类型："
        prop="visitorType"
        v-if="markForm.personnelType === 2"
      >
        <el-select
          :disabled="recordMarked"
          v-model="markForm.visitorType"
          placeholder="请选择外来人员类型"
          clearable
          style="width: 220px"
        >
          <el-option
            v-for="item in visitorOption"
            :key="item.visitorTypeCode"
            :label="item.visitorTypeName"
            :value="{
              value: item.visitorTypeCode,
              label: item.visitorTypeName,
            }"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标记：" prop="markType" v-if="isShowMark">
        <el-select
          :disabled="recordMarked"
          v-model="markForm.markType"
          placeholder="请选择标记"
          clearable
          @change="markChange"
          style="width: 220px"
        >
          <el-option
            v-for="item in markOption"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="名单组：" prop="group" v-if="isShowGroup">
        <el-select
          :disabled="recordMarked"
          v-model="markForm.group"
          placeholder="请选择名单组"
          clearable
          style="width: 220px"
        >
          <el-option
            v-for="item in groupOption"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="类型："
                    prop="markType">
        <el-select :disabled="recordMarked"
                   v-model="markForm.markType"
                   placeholder="请选择类型"
                   clearable
                   style="width:220px">
          <el-option v-for="item in types"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="区域：" prop="areaName" v-if="isShowAreaTime">
        <el-input
          :disabled="recordMarked"
          @click.native="showTree"
          :readonly="true"
          v-model="markForm.areaName"
          placeholder="请选择区域"
          style="width: 220px"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="开始时间："
        prop="effectiveTime"
        v-if="isShowAreaTime"
      >
        <el-date-picker
          v-model="markForm.effectiveTime"
          type="datetime"
          placeholder="请选择开始时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="结束时间："
        prop="expirationTime"
        v-if="isShowAreaTime"
      >
        <el-date-picker
          v-model="markForm.expirationTime"
          type="datetime"
          placeholder="请选择结束时间"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer flex-center">
      <el-button type="primary" @click="clickSubmit()">{{
        recordMarked ? "下发任务" : "确 定"
      }}</el-button>
      <el-button @click="cancleMark()">取 消</el-button>
    </div>
  </div>
</template>
<script>
import { api } from "../api";
import { Dates, Dic } from "$utils";
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    matchType: {
      type: [String, Number],
      default: 1,
    },
    matchRecordCode: {
      type: [String, Number],
      default: 1,
    },
    markData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    detailInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    matchType(value) {
      this.initTypes();
    },
  },
  created() {
    this.initTypes();
  },
  mounted() {},
  data() {
    return {
      markForm: {
        personnelType: "",
        visitorType: "",
        group: "",
        markType: "",
        areaList: [],
        areaName: "",
        effectiveTime: Dates.parse(Dates.format(new Date())),
        expirationTime: Dates.parse(Dates.format(new Date())),
      },
      types: [],
      rules: {
        areaName: [{ required: true, message: "请选择区域" }],
        markType: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
        personnelType: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
        visitorType: [
          { required: true, message: "请选择外来人员类型", trigger: "change" },
        ],
        group: [{ required: true, message: "请选择名单组", trigger: "change" }],
        effectiveTime: [{ required: true, message: "请选择开始时间" }],
        expirationTime: [{ required: true, message: "请选择结束时间" }],
      },
      recordMarked: false,
      personnelTypeOption: [
        {
          label: "员工",
          value: 1,
        },
        {
          label: "外来人员",
          value: 2,
        },
        {
          label: "忽略",
          value: 3,
        },
      ],
      visitorOption: [],
      markOption: [
        {
          name: "不再提醒",
          value: 1,
        },
        {
          name: "黑名单",
          value: 2,
        },
        // {
        //   name: 'VIP',
        //   value: 3
        // }
      ],
      groupOption: [],
      isShowGroup: false,
      isShowAreaTime: false,
      isShowMark: false,
    };
  },
  methods: {
    initTypes() {
      this.types =
        this.matchType === 1 ? Dic.find("SENU074") : Dic.find("SENU075");
    },
    clickSubmit() {
      if (!this.recordMarked) {
        this.submitMark();
      } else {
        this.$emit("assignTask");
      }
      // this.$emit('assignTask');
    },
    peopleChange(val) {
      // 选择了外来人员 调接口查外来人员类型
      if (val === 2) {
        this.isShowMark = true;
        this.getVisitorTypeList();
      } else {
        this.isShowAreaTime = false;
        this.isShowMark = false;
        this.isShowGroup = false;
      }
      if (val === 2 && this.markForm.markType === 1) {
        this.isShowAreaTime = true;
      }
    },
    markChange(val) {
      if (
        val === 1 &&
        this.markForm.personnelType !== 1 &&
        this.markForm.personnelType !== ""
      ) {
        this.isShowAreaTime = true;
      }
      if (val === 2) {
        this.isShowGroup = true;
        this.isShowAreaTime = false;
        this.getGroup(2);
      } else if (val === 3) {
        this.isShowGroup = true;
        this.isShowAreaTime = false;
        this.getGroup(4);
      } else if (val === 1) {
        this.isShowGroup = false;
      }
    },
    // 获取外来人员类型列表
    getVisitorTypeList() {
      this.$fetch(api.getVisitorTypeList, {}).then((res) => {
        if (res.success) {
          this.visitorOption = res.returnObj;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 获取名单组下面的名单
    getGroup(groupType) {
      let params = {
        type: groupType,
      };
      this.$fetch(api.queryGroup, params).then((res) => {
        if (res.success) {
          this.groupOption = res.returnObj;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    submitMark() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          let params = {
            personnelType: this.markForm.personnelType,
            matchRecordCode: this.matchRecordCode,
            matchType: this.matchType, //1是人员 2是车辆
            markType: this.markForm.markType,
            areaList: this.markForm.areaList,
            faceCode: this.markForm.group,
          };
          if (this.isShowAreaTime) {
            params.effectiveTime = Dates.format(this.markForm.effectiveTime);
            params.expirationTime = Dates.format(this.markForm.expirationTime);
          }
          // 如果this.markData是空对象
          if (Object.keys(this.markData).length === 0) {
            params.idCard = this.detailInfo.idCard;
            params.personName = this.detailInfo.personName;
            params.phone = this.detailInfo.phone;
            params.sex = this.detailInfo.sex;
          } else {
            params.idCard = this.markData.idCard;
            params.personName = this.markData.personName;
            params.phone = this.markData.phone;
            params.sex = this.markData.sex;
          }
          if (this.markForm.personnelType === 2) {
            params.visitorTypeCode = this.markForm.visitorType.value;
            params.visitorTypeName = this.markForm.visitorType.label;
          }
          // console.log('params9999999', params);
          this.$fetch(api.markMatchReocrd, params).then((res) => {
            if (res.success) {
              this.$message.success(res.msgContent);
              this.$refs.form.resetFields();
              this.$emit("cancleMark", true);
              // 注释此行是为了标记任务完成后，不需要在指定下发任务
              // this.recordMarked = true;
              // this.$emit('recordMarked', true);
            } else {
              this.$message.error(res.msgContent);
            }
          });
        }
      });
    },
    showTree() {
      if (this.recordMarked) {
        return;
      }
      this.$emit("showTree");
    },
    cancleMark() {
      if (this.recordMarked) {
        this.$confirm("您确定取消任务下发吗？", "取消任务下发", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$refs.form.resetFields();
          this.$emit("cancleMark", true);
        });
      } else {
        this.$refs.form.resetFields();
        this.$emit("cancleMark", false);
      }
    },
    changeCamersGroup(data, list) {
      this.markForm.areaList = [];
      this.markForm.areaName = "";
      let areaName = [];
      data.map((val) => {
        this.markForm.areaList.push(val.areaDevGroupCode);
        areaName.push(val.areaDevGroupName);
        this.markForm.areaName = areaName.join(",");
      });
    },
  },
};
</script>
<style lang='scss'>
</style>
